import styles from './style.module.css';
import FieldMasked from "react-input-mask";
import Field from "skin/entry/cmp/field";
import useCode from './hook';
import Button from 'skin/entry/cmp/button';
import { CountdownCircleTimer as Countdown } from 'react-countdown-circle-timer';
import Icon from 'skin/entry/cmp/icon';

export default function Code({ ok, phone, submitPhone }) {
	const { value, onChange, off, request, onComplete, send, wait, err } = useCode(phone, submitPhone);
	const clsCode = [styles.input, !value && styles.empty].filter(Boolean).join(' ');
	const id = [ok, wait, value.length === 4, off].findIndex(e => !!e);
	return <>
		<div className={styles.body}>
			<div className={styles.body}>
				<FieldMasked disabled={wait || ok} size={4} mask="9999" value={value} onChange={onChange}>
					{props => <Field err={!!err} disabledInput={wait || ok} className={clsCode} leftIcon={{ name: 'msg', color: err ? 'var(--error)' : 'var(--accent)' }} {...props} placeholder='____' type='layer1' />}
				</FieldMasked>
				{id === 0 && <Icon name='check' />}
				{id === 1 && <Icon name='load' />}
				{id === 2 && <Button disabled={ok || !!err} type='link' onClick={send}>Проверить код</Button>}
				{id === 3 && <Button type='link' disabled={ok || off} onClick={request}>Получить код повторно</Button>}
			</div>
			{
				(ok || wait)
					? null
					: <Countdown
						key={off ? 'code-off' : 'code-on'}
						isPlaying={off}
						duration={off ? 60 : 0}
						colors='var(--accent)'
						size={32}
						strokeWidth={2}
						onComplete={onComplete}
					>
						{t => <span className={styles.timer}>{t.remainingTime}</span>}
					</Countdown>
			}
		</div>
		{err ? <span className={styles.error}>{err}</span> : null}
	</>
}